import { actionTypes } from "../services/actionTypes";

const INITIAL_STATE = {
  serviceAreas: [],
  loading: false,
  error: null,
};

export default function serviceAreaReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    // Fetch Service Areas
    case actionTypes.FETCH_SERVICE_AREAS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case actionTypes.FETCH_SERVICE_AREAS_SUCCESS:
      return {
        ...state,
        loading: false,
        serviceAreas: action.payload.results || action.payload || [],
        error: null,
      };

    case actionTypes.FETCH_SERVICE_AREAS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Add Service Area
    case actionTypes.ADD_SERVICE_AREA_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case actionTypes.ADD_SERVICE_AREA_SUCCESS:
      return {
        ...state,
        loading: false,
        serviceAreas: [...state.serviceAreas, action.payload],
        error: null,
      };

    case actionTypes.ADD_SERVICE_AREA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Update Service Area
    case actionTypes.UPDATE_SERVICE_AREA_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case actionTypes.UPDATE_SERVICE_AREA_SUCCESS:
      return {
        ...state,
        loading: false,
        serviceAreas: state.serviceAreas.map((area) =>
          area.id === action.payload.id ? action.payload : area
        ),
        error: null,
      };

    case actionTypes.UPDATE_SERVICE_AREA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Delete Service Area
    case actionTypes.DELETE_SERVICE_AREA_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case actionTypes.DELETE_SERVICE_AREA_SUCCESS:
      return {
        ...state,
        loading: false,
        serviceAreas: state.serviceAreas.filter(
          (area) => area.id !== action.payload.id
        ),
        error: null,
      };

    case actionTypes.DELETE_SERVICE_AREA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
}
